import React from 'react'

import { filter, find } from 'lodash'
import { Accordion } from 'react-bootstrap'

import { DownloadLink } from '../dataStructures'
import { DownloadButton } from './DownloadButton'

export const Downloads = ({ uuid, downloadLinks }: {uuid: string, downloadLinks: DownloadLink[]}) => {
  const hasACS = find(downloadLinks, x => x.type === 'BODCACS') !== undefined
  const externalLinks = filter(downloadLinks, x => x.type !== 'BODCACS')

  if (downloadLinks.length === 0) return null

  return (
    <>
      {hasACS &&
        <div style={{ marginBottom: '0.5em' }}>
          <DownloadButton uuid={uuid}/>
        </div>
      }
      {externalLinks.length > 0 &&
        <Accordion>
          <Accordion.Item eventKey="0">
            <Accordion.Header>Data access</Accordion.Header>
            <Accordion.Body>
              <div>
                {externalLinks.map(x => {
                  let child
                  if (x.type === 'DAP') {
                    child = <>LDAP access: {x.uri}</>
                  } else if (x.type === 'OFFLINE') {
                    child = <>Contact: <a href={`mailto: ${x.uri}`}>{x.uri}</a></>
                  } else {
                    child = <a href={x.uri}>{x.uri}</a>
                  }
                  return <p key={x.uri}>{child}</p>
                })}
              </div>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      }
    </>
  )
}
